<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/keg3ds/tc-custom/9781467448741.jpg?1744436099203" alt="This image is the cover for the book Hope and Community"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hope and Community
      </h1>
      <p class="bookDescription body article font2">
        <i>The culmination of Kärkkäinen's multivolume magnum opus</i><br/><br/> This fifth and final volume of Veli-Matti Kärkkäinen's ambitious five-volume systematic theology develops a constructive Christian eschatology and ecclesiology in dialogue with the Christian tradition, with contemporary theology in all its global and contextual diversity, and with other major living faiths—Judaism, Islam, Buddhism, and Hinduism.<br/><br/> In Part One of the book Kärkkäinen discusses eschatology in the contexts of world faiths and natural sciences, including physical, cosmological, and neuroscientific theories. In Part Two, on ecclesiology, he adopts a deeply ecumenical approach. His proposal for greater Christian unity includes the various dimensions of the church's missional existence and a robust dialogical witness to other faith communities.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Veli-Matti Karkkainen
      </h2>
      
      <p class="authorDescription body article">Veli-Matti K&auml;rkk&auml;inen is professor of systematic theology at Fuller Theological Seminary, Pasadena,California, and docent of ecumenics at the University of Helsinki, Finland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68faf37e